export interface icJWT_Account{
  apikey: string,
  empID: string,
  Dept: string,
  CurrentDept: string,
  DeptORI: string,
  AuthLevel: string,
  FirstName: string,
  LastName: string,
  EmailID:string,
  Phone:string,
  eOTP: string,
  OTHER_DEPTS: string[]
  token_expire: string,
  isSuperAdmin:string
}

export interface LabInfo {
  LAB_FN: string,
  LAB_IMAGE: string,
  LAB_SN: string
  LAB_STATE: string
}

export interface DDL{
  DDL_Type: string,
  DDL_Desc: string,
  DDL_Hover: string
}

export interface StateList{
  name: string,
  abbreviation: string
}

export interface NIBIN_AdditionalInfoEvidence {
  EV_Type?: string | null,
  EV_ID?: number|null,
  SelectedForAssoc?: boolean | null,
  Assoc_Type?: string | null,
  EV_Text?: string | null,
}

export interface IncidentRecord {
  SelectedForReport: boolean,
  SelectedAsPrimary?: boolean,
  RPT_AdditionalInfoEvidence?: NIBIN_AdditionalInfoEvidence[] | null,
  ChangeHistory?: ChangeHistory[] | null,

  ID: number|null,
  IncidentID: string|null,
  ReportID: string|null,
  LabNumber: string|null,
  Dept: string|null,
  CaseNumber: string|null,
  OccurrenceDate: string|null,
  OccurrenceTime: string|null,
  SubmissionDate: string|null,
  Inc_Type: string|null,
  Inc_Location: string|null,
  Inc_City: string|null,
  Inc_State: string|null,
  County: string|null,
  Latitude: number|null,
  Longitude: number|null,
  Status: string|null,
  Notes:string|null,
  NJPopNo: number|string|null,
  Inc_RelatedArea: string|null,
  Lab:string|null,
  DeptORI: string|null,
  NJPOPRejectReason: string | null

  Persons: PersonRecord[]|null,
  Weapon: WeaponRecord[]|null,
  Ballistics: BallisticRecord[]|null,
  Reports: ReportRecord[]|null
}

export interface PersonRecord {
  ID: number|null,
  IncidentID: string|null,
  Role:string|null,
  Rank: string|null,
  FIRSTNAME: string|null,
  LASTNAME: string|null,
  MI: string|null,
  Suffix: string|null,
  DOB: string|null,
  Address: string|null,
  Phone: string|null,
  Email: string|null,
  Age: number|null,
  Sex: string|null,
  Relationship: string|null,
  SBINo: string|null,
  AdditionalNotes: string|null,
  SBIState: string|null,
  FBI: string|null,
}
export interface WeaponRecord {
  SelectedForAssoc?: boolean|null,
  Assoc_Type?:string | null,

  ID: number|null,
  IncidentID: string|null,
  MANUFACTURER: string|null,
  MANUFACTURER_NAME: string|null,
  MAKE: string|null,
  MODEL: string|null,
  W_CLASS: string|null,
  CALIBER: string|null,
  SERIAL_NUMBER: string|null,
  W_TYPE: string|null,
  W_TYPE_DESC: string|null,
  EvidenceMarker: string|null,
  RGID_State: string|null,
  RGID_Number: string|null,
  Notes: string|null,
  PreviousHit: string|null,
  ORIGIN: string|null,
  ORIGIN_COUNTRY_NAME: string|null,
  IMPORTER_NAME: string|null,
  REC_TIME_TO_CRIME: string|null,
  IDENTIFYING_MARKS: string|null,
  OBLITERATED_INDICATOR: string|null,
  CT_Ghost_Gun: boolean,
  SearModifyFlag: boolean,
  DTOFCOLLECTION:string|null,
  DTOFSUBMISSION:string|null
}

export interface BallisticRecord {
  SelectedForAssoc?: boolean|null,
  Assoc_Type?:string | null,

  ID:number|null,
  VGID_CPart: string|null,
  IncidentID: string|null,
  Item_Quantity: number|null,
  Headstamp: string|null,
  Caliber_Type: string|null,
  Item_Type: string|null,
  CL_LG: string|null,
  CL_Twist: string|null,
  CL_Type: string|null,
  EvidenceMarker: string|null,
  VGID_State: string|null,
  VGID_Number: string|null,
  VGID_Status: string|null,
  Notes: string|null,
  PreviousHit: string|null,
  DTOFCOLLECTION:string|null,
  DTOFSUBMISSION:string|null
}

export interface ReportRecord {
  ID:number|null,
  ReportID:string|null,
  Lab:string|null,
  UserID:string|null,
  EnteredDateTime:string|null,
  ReportStatus:string|null,
  NOTE:string|null,
  ReferenceNumber:string|null,
  Examiner:string|null,
  Reviewer:string|null,
  NIBINHit:boolean|null,
  showAllWeaponsFlag:boolean|null,
  ReportType:string|null,
  UpdateNo:string|null,
  EmailSent:string|null,
  NumOfEmailSent:string|null,
  UpdatedDateTime:string|null,
  Assoc_VGID_State:string|null,
  Assoc_VGID_Number:string|null,
  Assoc_VGID_Status:string|null,

  Incidents?: IncidentRecord[] | null,
}

export interface IncidentSearchParams {
  labs?: string[] | null,
  agency?: string | null,
  casenumber?: string | null,
  labnumber?: string | null,
  fromdate?: string | null,
  referencenumber?: string| null,
  todate?: string | null,
  person_firstname?:string|null,
  person_lastname?:string|null,
  person_sbi?:string|null,
  person_fbi?:string|null,
  weapon_serial?: string|null
}

export interface NJPOPSearchParams{
  county? : string | null,
  city? : string | null,
  agency?: string | null,
  casenumber?: string | null,
  fromDate: string|null,
  toDate: string|null
}

export interface LinkReportIncidentReq {
  ReportID:string,
  IncidentID:string
  SelectedAsPrimary:boolean | null | undefined
}

export interface ReportAssocReq {
  ReportID:string | null,
  IncidentID:string | null,
  EvidenceType:string | null,
  EvidenceID:number | null,
  Assoc_Type?:string | null
}

export interface ReportUpdateStatus {
  ReportID:string | null,
  Status: string | null
}

export interface WeaponDeleteReq {
  IncidentID:string | null,
  WeaponID: number | null
}

export interface BallisticsDeleteReq {
  IncidentID:string | null,
  BallisticID: number | null
}

export interface PersonDeleteReq {
  IncidentID:string | null,
  PersonID: number | null
}

export interface IncidentSaveEditReq {
  IncidentRecord: IncidentRecord | null,
  WeaponDeleteReqs: WeaponDeleteReq[] | null
  BallisticsDeleteReqs: BallisticsDeleteReq[] | null
  PersonDeleteReqs: PersonDeleteReq[] | null
  RequestCopy?: boolean | null
}



export enum ReportModify {
  ADD,
  EDIT
}

export interface EmailList {
  Entity: string | null,
  Firstname:string | null,
  ID: number,
  Lastname: string| null,
  added_by_empid: string|null,
  deptCode: string|null,
  email: string | null,
  group: string | null
}

export interface EmailGroup{
  ID: number,
  added_by_empid: string|null,
  deptCode: string|null,
  group: string | null
}

export  interface EmailSendReq {
  to:string[],
  cc: string[],
  bcc: string[],
  replyto: string[],
  ReportID:string,
  subject:string,
  message:string,
  files: string[],
  includeLA: boolean,
  forceSend?: boolean | null,
}

export interface CountyCityList {
  ID?:number | null
  County?: string | null,
  City?: string | null,
  State?: string | null,

}

export interface AgencyORIList {
  ID?:number | null,
  DeptName?: string | null,
  DeptORI?: string | null,
  City?: string | null,
  County?: string | null,
  State?: string | null,

}

export interface AgencyCountyCityList {
  ID?:number | null
  Agency?: string | null,
  ORI?: string | null,
  County?: string | null,
  City?: string | null,
  State?: string | null,

}

export interface APIResponse {
  MessageCode?: number | null,
  AnyData?: any,

}

export interface PendingChangeList{
  ChangeID?: string | null,
  ItemID: string| null,
  ItemType: string | null,
  ReqLab?: string| null,
  AssignedLab?: string | null,
  ReqDateTime?: string | null,
  Changes?: PendingChangeListITEM[] | null
}
export interface PendingChangeListITEM {
  IncidentID?: string| null,
  Property?: string | null,
  OldValue?: string | null,
  NewValue?: string | null,
  ChangeReason?: string | null
}

export interface TriggerAssociatedIncidentsType {
  ID:number | null,
  EType:string
}

export interface AssociatedEvidencesResp {
  AssociatedBallistic?: BallisticRecord[] | null,
  AssociatedWeapon?: WeaponRecord[] | null,
  Incidents?:IncidentRecord[] | null
}

export interface ChangeHistory{
  ID?:number | null,
  ChangeBatchID?:number | null,
  ChangeRecordType?:number | null,
  ChangeRecordID?:number | null,
  ChangeTimestamp?:number | null,
  ChangeUser?:number | null,
  ChangeDept?:number | null,
  ChangeType?:number | null,
  ChangeItemType?:number | null,
  ChangeItemID?:number | null,
  ChangeItemField?:number | null,
  OldValue?:number | null,
  NewValue?:number | null
}

export interface ReportEmailLog{
  FirstName?: string | null,
  LastName?: string | null,
  SentTimeStamp?: string | null,
  ToEmail?: string | null,
  ReportID?: string | null
}
